import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui';
import logo from '@/assets/logo.png';

export function TermsOfService(): React.JSX.Element {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-white">
            {/* Navigation */}
            <nav className="fixed top-0 w-full bg-white/80 backdrop-blur-md z-50 border-b border-gray-100">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center h-24">
                        <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
                            <img src={logo} alt="List8.app Logo" className="h-20 w-auto" />
                        </div>
                        <div className="flex items-center space-x-4">
                            <Button variant="ghost" onClick={() => navigate('/login')}>
                                Log in
                            </Button>
                            <Button onClick={() => navigate('/signup')}>
                                Start Today
                            </Button>
                        </div>
                    </div>
                </div>
            </nav>

            {/* Content */}
            <div className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto">
                <h1 className="text-4xl font-bold text-gray-900 mb-2">Terms of Service</h1>
                <p className="text-gray-500 mb-8">Last Updated: {new Date().toLocaleDateString()}</p>

                <div className="prose prose-lg text-gray-600 space-y-8">
                    <p>
                        Welcome to List8.app! By using our site, you agree to these terms. We've kept them simple because nobody likes reading legal mumbo-jumbo.
                    </p>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">1. The Basics</h2>
                        <p>
                            You grant us permission to edit the photos you upload. You promise that you own the rights to these photos or have permission to use them.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Credits & Payments</h2>
                        <p>
                            Our services run on credits. You buy them, you use them. Credits don't expire, but they are non-refundable once purchased, unless there's a technical error on our end.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Acceptable Use</h2>
                        <p>
                            Don't upload anything illegal or offensive. Be nice. Don't try to hack us. If you do, we'll have to ban you, and nobody wants that.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Liability</h2>
                        <p>
                            We do our best to provide amazing results, but sometimes AI can be unpredictable. We're not liable for any lost business or damages resulting from the use of our images. Always check your photos before publishing!
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Changes</h2>
                        <p>
                            We might update these terms from time to time. If we do something big, we'll let you know.
                        </p>
                    </section>
                </div>
            </div>

            {/* Footer */}
            <footer className="bg-gray-900 text-white py-12 mt-auto">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <p className="text-gray-400">
                        &copy; {new Date().getFullYear()} List8.app. All rights reserved.
                    </p>
                </div>
            </footer>
        </div>
    );
}
